import script from "./AppSocialNetworks.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSocialNetworks.vue?vue&type=script&setup=true&lang=js"

import "./AppSocialNetworks.vue?vue&type=style&index=0&id=ec5005f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec5005f6"]])

export default __exports__